/* =========================================
   LUMIN · Ing clave (fade desktop + swipe mobile)
   ========================================= */
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.lumin-ingredientes-clave');
  if (!section) return;

  const items = section.querySelectorAll('.ingrediente-item');
  const images = section.querySelectorAll('.ingrediente-image');

  // === Desktop (fade entre imágenes) ===
  if (window.innerWidth > 768 && items.length && images.length) {
    items.forEach((item, idx) => {
      item.addEventListener('mouseenter', () => {
        items.forEach(i => i.classList.remove('active'));
        item.classList.add('active');
        images.forEach((img, i) => {
          img.classList.toggle('active', i === idx);
        });
      });
    });
  }

  // === Mobile (carrusel swipe nativo) ===
  if (window.innerWidth <= 768) {
    const track = section.querySelector('.ingredientes-track');
    if (!track) return;

    let isDown = false, startX, scrollLeft;

    track.addEventListener('mousedown', e => {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', () => (isDown = false));
    track.addEventListener('mouseup', () => (isDown = false));
    track.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.5;
      track.scrollLeft = scrollLeft - walk;
    });
  }
});
